import RequestAbstract from '../abstract';

export default class MerchantTerminals extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/public-merchant-terminals';
    }

    getTerminalKeys = async (terminalId) => {
        // terminalId should be a number
        const filter = [[{ field: 'id', op: '=', value: terminalId }]];
        return this.getFiltered(
            `${this.link}/show-keys`,
            filter,
            [],
            {
                page: 0,
                pageSize: 5
            },
            {}
        );
    };
    resetApiKeys = async (ids) => {
        return this.loadWithAuth(this.link + '/reset-api-keys/' + ids, {
            method: 'GET'
        });
    };
    createPaymentOrder = async (terminalId, data) => {
        return this.loadWithAuth(this.link + '/create-payment-order', {
            method: 'POST',
            body: JSON.stringify({
                id: terminalId,
                ...data
            })
        });
    };
    createPayoutOrder = async (terminalId, data) => {
        return this.loadWithAuth(this.link + '/create-payout-order', {
            method: 'POST',
            body: JSON.stringify({
                id: terminalId,
                ...data
            })
        });
    };
    // transfer-balance
    transferBalance = async (data) => {
        return this.loadWithAuth(this.link + '/transfer-balance', {
            method: 'POST',
            body: JSON.stringify(data)
        });
    };
}
